<template>
  <div class="page" v-loading="loading">
       <div class="page__hd">
            <div class="page__title">确认物品清单</div>
            <div class="page__desc">请与管家确认以下清单中的物品均完好，然后再签署合同</div>
        </div>
        <div class="page__bd"> * 若退房时有物品损坏，则根据物品金额进行赔偿</div>   
      
        <el-table :data="dataInfo" height="50vh" style="width: 100%" >
            <el-table-column prop="name"  label="物品名称"  align="center"></el-table-column>
            <el-table-column prop="price" label="物品价格"  align="center" ></el-table-column>
            <el-table-column prop="amount" label="物品数量" align="center"></el-table-column>
        </el-table>

        <div class="page__ft"> 
             <div class="btn">
               <el-button style="width:100%" type="primary" @click="plaView">预览合同</el-button> 
            </div>
            <div class="btn">
                <el-button  style="width:100%" type="success"  @click="submit">确认签署</el-button>
            </div> 
        </div>
        
        <el-dialog title="提示" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div v-loading="dialogLoadding">
                <div>即将调用您的数字证书进行合同签署，您在安全签署环境中，请放心签署！</div>
                <div style="margin-top:20px;">
                    <el-form ref="form" :model="form" label-width="60px">
                        <el-form-item label="手机号">
                            <el-input v-model="form.phone" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="验证码">
                             <el-input placeholder="请输入验证码" v-model="form.code">
                                <template slot="append">
                                    <div  @click="sendCode">
                                        {{codeText||'获取验证码'}}
                                    </div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form> 
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog  title="提示" :visible.sync="centerDialogVisible" width="50%" center :close-on-click-modal="false" :show-close="false">
            <span>签署成功！</span>
            <span slot="footer" class="dialog-footer"> 
                <el-button type="primary" @click="submitBtn">确 定</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script> 
    import axios from "axios";
    import {Message} from 'element-ui';
     import wx from "weixin-js-sdk";
export default {
  components: {
    
  },
  data() {
    return {
      dataInfo:[],
      codeText:'',
      sendDisabled:false,
      dialogLoadding:false,
      centerDialogVisible:false,
      form:{
          phone:'',
          code:''
      },  
      dialogVisible:false,  
      loading:false, 
    }
  },
  created() {     
       localStorage.setItem("token", this.$route.query.token || "");
            localStorage.setItem("orgID", this.$route.query.orgID || "");
            localStorage.setItem("type", this.$route.query.client || "");
        document.title = "合同签署"; 
        this.queryAssets();
        this.form.phone = this.$route.query.phone
  },
  methods: {
    // 获取物品列表
    queryAssets(){
        this.loading = true
         let url = axios.defaults.baseURL.replace('v1/org/','')
        axios({
            method: 'post',
            // url: "/api/v1/renter/leases/query",
            url: url+"v2/users/leases/assets",
            headers: {
                'Authorization': this.$route.query.token,
                'PYDDot-Client-Type':this.$route.query.client,
                'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)},
            data: {
                leaseID:this.$route.query.leaseID,
                orgID:this.$route.query.orgID, 
            }
        }).then(value => {
            if (value.data.data) {
                this.dataInfo = value.data.data;
                 this.dataInfo.forEach(item=>{
                     item.price = this.numPrice(item.price/100)
                 }) 
            }
            if (value.data.code !== 0) { 
                this.$message.error(value.data.message)
            }
        }).catch((err) => {
            Message.error(err.toString());
        }).finally(()=>{
            this.loading = false
        }); 
    },
    // 格式化金额
    numPrice(num){
        console.log(num)
        if (num && num !== 0) {
            num = num.toFixed(2);
            }
            return num.toString().replace(/\d+/, function (n) {
            // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                return $1 + ",";
            });
        });
    },
    // /预览合同
    plaView(){
        let that = this
        wx.miniProgram.getEnv(function() {
            wx.miniProgram.navigateTo({
                url: "/pages/lease/contract?"
                    + "leaseID=" + that.$route.query.leaseID
                    + "&contractID=" + that.$route.query.contractID
                    + "&orgID=" + that.$route.query.orgID
            });
        });
    },
    // 点击确定
    submit(){  
        this.dialogVisible = true 
         
    },
    handleClose(){
        this.dialogVisible = false;
    }, 
    // 跳转服务协议
    // toXieyi(){
    //      wx.miniProgram.getEnv(function() {
    //         wx.miniProgram.navigateTo({
    //             url: "/pages/lease/aggreement"
    //         });
    //     });
    // },
    // 发送验证码
    sendCode(){ 
        var that = this; 
        if (this.sendDisabled) {
            return
        }
        
         if (/^1\d{10}$/.test(this.form.phone)) {
            this.sendDisabled = true 
         }
        let url = axios.defaults.baseURL.replace('v1/org/','')
         axios({
            method: 'post', 
            url: url+"v1/users/smscodes/send",
            headers: {'Authorization': this.$route.query.token,'PYDDot-Client-Type':this.$route.query.client,'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)},
            data: {
                phone:this.$route.query.phone, 
            }
            }).then(value => {
                if (value.data.code==0) {
                   var seconds = 60;
                    that.$message.success('发送成功！');
                    that.codeText = seconds + "秒后重发" 
                    var interval = setInterval(function() {
                        if (seconds > 0) {
                            seconds--;
                            var secondStr = (seconds > 10 ? seconds : "0" + seconds);
                            that.codeText = secondStr + "秒后重发" 
                        } else {
                            that.codeText = "重新发送" 
                           that.sendDisabled = false 
                            clearInterval(interval);
                        }
                    }, 1000);
                }else { 
                    that.$message.error(value.data.message)
                    that.this.sendDisabled = false
                }
            }).catch((err) => {
                Message.error(err.toString());
            }).finally(()=>{
                that.loading = false
            }); 

    },
    // 签署协议
    handleSubmit(){ 
        if(this.form.code==""){
           return this.$message.error('请输入验证码！')
        }
        this.dialogLoadding = true;
        var that = this;
        let url = axios.defaults.baseURL.replace('v1/org/','')
        axios({
            method: 'post', 
            url: url+"v2/users/contracts/sign",
            headers: {'Authorization': this.$route.query.token,'PYDDot-Client-Type':this.$route.query.client,'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)},
            data: { 
                leaseID:this.$route.query.leaseID,
                contractID:this.$route.query.contractID,
                orgID:this.$route.query.orgID,
                phone:this.form.phone,
                code:this.form.code
            }
            }).then(value => {
                if (value.data.code==0) { 
                    that.centerDialogVisible = true;
                             
                }else { 
                    that.$message.error(value.data.message) 
                }
            }).catch((err) => {
                Message.error(err.toString());
            }).finally(()=>{
                that.dialogLoadding = false
            }); 
    },
    submitBtn(){
         wx.miniProgram.getEnv(function() { 
            wx.miniProgram.navigateBack({
                delta: 1
            });
        });
    }
  }
}
</script>

<style scoped lang="scss">
page{
    background-color: #F8F8F8;
    font-size: 16px;
    font-family: -apple-system-font,Helvetica Neue,Helvetica,sans-serif;
}
.page__hd {
    padding: 30px;
}
.page__bd {
    padding-bottom: 20px;
    font-size: 12px;
    color: red;
}

.page__ft{
    margin-top: 40px;
    text-align: center;
    // display: flex;
    
}
.btn{
    width: 90%;
    margin: 10px auto;
    // height: 35px;
    // background-color: rgb(65, 199, 146); 
    // color: #fff;
    // line-height: 35px;
    // font-size: 14px;
    // border-radius: 5px;
    // text-align: center;
    }
// .btn:active{
//     opacity: 0.5;
// }
.page__title {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
}

.page__desc {
    margin-top: 5px;
    color: #888888;
    text-align: left;
    font-size: 14px;
}
 
    .box{
        width: 100%;
        display: flex;
    }
    .box-item{
        width: 33.3%;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        text-align: center;
        margin-top: -1px;
        margin-left: -1px;
    }
    .xieyi{
        font-size: 12px;
        color: #0b5fbe;  
        display: block;
    } 
    .xieyiBox{
        align-items: center;
        display: flex;
        padding-left: 10%;
        input{
            margin: 0;
        }
    }
    .test{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    z-index: 1;
    height: 100%;
    background: rgba(0,0,0,0.4);
}
.erroDialog{
    position: absolute;
    width: 80%;  
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 999;
    background-color: #fff; 
    border-radius: 10px;
    padding: 10px;
    .main{
        margin: 20px 0;
    }
    .footer{ 
        display: flex;
        justify-content: end;
        padding: 0 10px ;
        .quxiao{
            background-color: #ccc;
        }
    }
}
.loding{
    display: inline-block;
    width: 30px;
    height: 30px;
}
.qianshuMain{
    padding: 20px;
    background-color: #222;
    color: #eee;
    border-radius: 10px 10px 0 0 ;
    font-size: 14px;
}
.fromMain{
    width: 100%;
    padding: 10px;
    .inputBox{
        margin-top: 20px;
        display: flex;
        input{
            margin-top: 10px;
            border: none;
            border-bottom: 1px solid #ccc;
            outline:medium;
            padding: 5px;
        }
        
    }
}
.huoquyanzhengma{
    font-size: 13px;
    color: #4b95eb;
}
.huoquyanzhengma:active{
    color: #0b5fbe;
}
</style>
